import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { ModuleTokens } from './clients-base.constant';
import { reducer } from './clients-base.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(
      ModuleTokens.Name,
      reducer
    )
  ]
})
export class ClientsBaseModule {

}
